export default "__VITE_ASSET__CffC1zg8__"